namespace Solovis.UI {

    /**
     * Show alert dialog and call callback function after it is dismissed.
     * @param messageHtml
     * @param title
     * @param callback
     */
    export function alert(
        messageHtml: string | JQuery,
        title?: string,
        callback?: () => void
    ): void {
        var alertBody = $("<div>")
            .html(messageHtml as any);

        var dialog = null;

        var dialogOptions: any = {
            container: alertBody,
            modal: true,
            autoOpen: true,
            center: true,
            destroyOnClose: true,
            actions: ["Close"],
            minWidth: 200,
            maxWidth: 500,

            buttons: [
                {
                    label: "OK",
                    click: function () {
                        dialog.close();
                    }
                }
            ],

            deactivate: function () {
                if (callback) {
                    callback();
                }
            }
        };

        if (title) {
            dialogOptions.title = title;
        }
        else {
            dialogOptions.title = false;
        }

        dialog = new (Solovis as any).UI.Dialog(dialogOptions);
    };


    /**
     * Show alert dialog via async Promise.
     * Return value is true if confirmed.
     * @param messageHtml
     * @param title     
     */
    export function alertAsync(
        messageHtml: string | JQuery,
        title?: string
    ): Promise<boolean> {
        let promise = new Promise<boolean>(function (resolve, reject) {
            Solovis.UI.alert(messageHtml, title, () => {
                resolve(true);
            });
        });

        return promise;
    }


    /**
     * Show confirmation dialog via async Promise.
     * Return value is true if confirmed.
     * @param messageHtml
     * @param title     
     */
    export function confirmAsync(
        messageHtml: string | JQuery,
        title?: string
    ): Promise<boolean> {
        let promise = new Promise<boolean>(function (resolve, reject) {
            Solovis.UI.confirm(messageHtml, title, (confirmed) => {
                resolve(confirmed);
            });
        });

        return promise;    
    }


    /**
     * Show confirmation dialog and call callback after it is dismissed.
     * Callback should be of form function (confirmed).
     * @param messageHtml
     * @param title
     * @param callback
     */
    export function confirm(
        messageHtml: string | JQuery,
        title?: string,
        callback?: (confirmed: boolean) => void
    ): void {        

        var confirmBody = $("<div>")
            .html(messageHtml as any);

        var dialog = null;

        var dialogOptions: any = {
            container: confirmBody,
            modal: true,
            autoOpen: true,
            center: true,
            destroyOnClose: true,
            minWidth: 200,
            maxWidth: 500,

            buttons: [
                {
                    label: "OK",
                    click: function () {
                        dialog.close();

                        if (callback) {
                            callback(true);
                        }
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();

                        if (callback) {
                            callback(false);
                        }
                    }
                },
            ]
        };

        if (title) {
            dialogOptions.title = title;
        }
        else {
            dialogOptions.title = false;
        }

        dialog = new (Solovis as any).UI.Dialog(dialogOptions);
    };

}
